import React, { useMemo, useCallback } from 'react'
import { useShoppingCartContext } from '../../providers/ShoppingCartProvider'
import Warning from './Types/Warning'

const ItemsExceededStock = () => {
  const {
    itemsExceededStock,
    setItemsExceededStock,
  } = useShoppingCartContext()
  const style = useMemo(
    () => ({ fontSize: '16px' }),
    [],
  )

  const handleNotificationOnHide = useCallback(
    () => {
      setItemsExceededStock([])
    },
    [setItemsExceededStock],
  )

  return useMemo(
    () => (
      <>
        {itemsExceededStock.map(item => {
          const message = (
            <span style={style}>
              <b>Important!</b>
              {' '}
              The quantity of
              {' '}
              {item.product.brand.name}
              {' '}
              {item.product.sku}
              ... has been changed to
              {' '}
              {item.modifiers.quantity}
              {' '}
              unit(s)
              due to real-time updates in stock availability.
            </span>
          )
          return (
            <Warning
              key={`itemStockNotif-${item.product.productId}`}
              id={`itemStockNotif-${item.product.productId}`}
              message={message}
              timeout={14000}
              cb={handleNotificationOnHide}
            />
          )
        })}
      </>
    ),
    [style, itemsExceededStock, handleNotificationOnHide],
  )
}

export default ItemsExceededStock
